// Zayi girişi için seçilebilir öğeler: malzemeler + reçeteler (urun_malzeme_id'si
// olmayan TABAK reçeteleri). Bağlı reçeteler (urun_malzeme_id var) zaten malzeme
// olarak listede olduğundan dışlanır (duplicate önleme).

/**
 * @returns {Array<{value:string,label:string,searchText:string,birim:string,kind:'malzeme'|'recipe',id:number}>}
 */
export function buildZayiOptions(malzemeler, recipes, markaByMalzemeId = {}) {
  const opts = [];

  (malzemeler || []).forEach((m) => {
    const marka = markaByMalzemeId[m.id];
    const base = `${m.ad} (${m.birim})`;
    const label = marka ? `${base} • ${marka}` : base;
    const searchText = m.kod ? `${base} ${m.kod}` : base;
    opts.push({ value: `m:${m.id}`, label, searchText, birim: m.birim || 'KG', kind: 'malzeme', id: m.id });
  });

  (recipes || []).forEach((r) => {
    if (r.urun_malzeme_id) return; // malzeme olarak zaten listede
    const birim = r.porsiyon_birim || 'PORSIYON';
    const marka = r.marka ? ` • ${r.marka}` : '';
    opts.push({
      value: `r:${r.id}`,
      label: `🍽️ ${r.ad} (reçete)${marka}`,
      searchText: `${r.ad} reçete`,
      birim,
      kind: 'recipe',
      id: r.id,
    });
  });

  return opts.sort((a, b) => a.label.localeCompare(b.label, 'tr'));
}

/** "m:5" / "r:3" → {kind, id}. Boş/null → null. */
export function parseZayiValue(value) {
  if (!value) return null;
  const [kind, idStr] = String(value).split(':');
  const id = parseInt(idStr, 10);
  return { kind: kind === 'r' ? 'recipe' : 'malzeme', id };
}
